<template>
  <transition appear name="from-below">
    <v-row class="name-list-block px-4 px-md-16 " align="end" justify="center">
      <span v-for="(person, i) in data.people" :key="i">
        <a rel="noopener" target="_blank" :href="person.link" v-if="person.link">{{person.name}}</a>
        <span v-else>{{person.name}}</span>
        <span v-if="i < data.people.length -1">-&nbsp;</span>
      </span>
    </v-row>
  </transition>
</template>

<script>

export default {
  name: 'ContentNameList',
  props: {
    data: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.name-list-block {
  font-family: $heading-font-family;
}
</style>
